import {
  parseLista,
  procedimentoNoPeriodo,
} from './functions.js'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object|null} mes Mês selecionado no filtro.
 * @param {Object} equipe Equipe selecionada.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  mes = null,
  equipe
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const semTra = item.num_atend_proced_restar_atraum == 0

      if (!mes) {
        return semTra
      }

      const lista = [
        ...parseLista(item.dados),
        ...parseLista(item.procedimentos),
      ]

      const registroMes = lista.find((dado) => {
        const mesmaEquipe = !dado.nu_ine || equipe.ine_esb == dado.nu_ine

        return (
          Number(dado.nm) === 0 &&
          procedimentoNoPeriodo(dado, mes) &&
          mesmaEquipe
        )
      })

      return semTra && !!registroMes
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const tratArt = item.num_atend_proced_restar_atraum > 0

      if (!mes) {
        return tratArt
      }

      const mesesSelecionados = mes.value || []
      const anoSelecionado = mes.nu_ano

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          mesesSelecionados.includes(Number(dado.nu_mes)) &&
          Number(dado.nu_ano) === Number(anoSelecionado) &&
          equipe.ine_esb == dado.nu_ine
        )
      })

      return tratArt && !!registroMes
    })
  }

  return cadastros_filtrados
}
